<template>
  <div class="afdc-list-results">
    <template v-if="!$store.getters.getLoadingRouteStations">
      <template v-if="$store.getters.getRouteError">
        <p class="afdc-alert afdc-alert-warning"><em>{{ $store.getters.getRouteError }}</em></p>
      </template>

      <template v-else>
        <template v-if="routeStations.length > 0">
          <p>{{ routeCountText }}</p>
          <p class="afdc-kiosk-mode-hide">
            <button class="afdc-btn afdc-btn-secondary" v-if="displayDirections" @click="toggleRouteDirections">
              <font-awesome-icon icon="car" class="afdc-fa-icon"/>&nbsp;
              {{ $t('See Route Directions') }}
            </button>
          </p>
          <p class="afdc-kiosk-mode-hide">
            <a v-bind:href="routeStationsCsv" class="afdc-dark-link">
              <font-awesome-icon icon="download" class="afdc-fa-icon afdc-float-left afdc-route-download"/> {{ $t('Download list of stations on route') }}
            </a>
            <span class="afdc-clearfix"></span>
          </p>

          <div v-for="station in routeStations" v-bind:key="station.id">
            <find-result-station mode="route" v-bind:station="station"/>
          </div>
        </template>

        <template v-else>
          <p class="afdc-alert afdc-alert-info"><em>{{ $t('There are no stations along the route that match your filters.') }}</em></p>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import FindResultStation from '@/components/FindResultStation.vue';

export default {
  name: 'MapRoute',
  props: ['map'],

  components: {
    FindResultStation,
  },

  computed: {
    routeStations() {
      return this.$store.getters.routeStations;
    },

    displayDirections() {
      return this.$store.getters.isDisplayDirections;
    },

    routeCountText() {
      const count = this.$store.getters.routeStationsCount;
      return this.$sprintf(this.$ngettext('%s station along the route', '%s stations along the route', count), this.$formatNumber(count));
    },

    routeStationsCsv() {
      return this.$store.getters.routeStationsCsv;
    },
  },

  watch: {
    '$store.getters.getFiltersFindRoute': {
      immediate: true,
      handler: 'fetchData',
    },

    '$store.getters.isNavActiveFindModeRoute': 'fetchData',
  },

  methods: {
    fetchData() {
      if (this.$store.getters.isNavActiveFindModeRoute) {
        this.$store.dispatch('fetchRouteStations', this.$store.getters.getFiltersWithDefaults);
      }
    },
    toggleRouteDirections() {
      this.$store.commit('setDirectionPopup', true);
    },
  },
};
</script>

<style lang="scss">
.route-download {
  margin: 10px 10px 10px 0;
  font-size: 30px;
}
</style>
